export default __webpack_public_path__ + "static/screens-1ce49e61d4f3203890cdc9c3a3258bb0.png";